import React, { useState } from 'react';
import VisuallyHiddenAnnouncementContext, { RefElementType } from './VisuallyHiddenAnnouncementContext';

interface VisuallyHiddenAnnouncementProps {
	children: React.ReactNode;
}

/**
 * Displays a page change alert for screen readers
 *
 * @param {*} props
 * @returns
 */
function VisuallyHiddenAnnouncement(props: VisuallyHiddenAnnouncementProps) {
	const [alert, setAlert] = useState('');
	const [mainRef, setMainRef] = useState<RefElementType | null>(null);

	return (
		<VisuallyHiddenAnnouncementContext.Provider value={{ setAlert, mainRef, setMainRef }}>
			{props.children}
			<div className="roc-visually-hidden" role="status" aria-live="assertive" aria-atomic="true">
				{alert}
			</div>
		</VisuallyHiddenAnnouncementContext.Provider>
	);
}

export default VisuallyHiddenAnnouncement;
